import React, { useEffect, useLayoutEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Redirect } from "react-router-dom";
import { Box, Flex, Text, useToast, Button } from "@chakra-ui/react";
import Sidebar from "./Sidebar";
import BuildForm from "./BuildForm";
import FormConfiguration from "./FormConfiguration";
import PreviewAndEmbed from "./PreviewAndEmbed";
import Integration from "./Integration";
import {
  setTemplateProgressType,
  updateTemplateProgressType,
} from "../../redux/actions/templateProgressActions";
import { updateTemplate } from "../../redux/actions/templateActions";
import WorkFlow_1_Icon from "./Icons/WorkFlow1";
import ArrowIcon from "./Icons/Arrow";
import WorkFlow_2_Icon from "./Icons/WorkFlow2";
import WorkFlow_3_Icon from "./Icons/WorkFlow3";
import WorkFlow_4_Icon from "./Icons/WorkFlow4";

const TEMPLATE_PROGRESS_TYPES = {
  formConfig: "FORM_CONFIG",
  buildForm: "BUILD_FORM",
  integrate: "INTEGRATE",
  embedForm: "EMBED_FORM",
};

const Main = ({
  currentProgressType,
  httpStatus,
  dispatchSetTemplateProgress,
  dispatchUpdateTemplate,
  dispatchUpdateTemplateProgressType,
  updated,
}) => {
  console.log("currentProgressType", currentProgressType);
  const [templateUpdated, setTemplateUpdated] = useState(false);
  const toast = useToast();
  const handleOnClick = (e, type) => {
    e.preventDefault();
    if (
      currentProgressType == TEMPLATE_PROGRESS_TYPES.embedForm &&
      type == "next"
    ) {
      return dispatchUpdateTemplate();
    }
    dispatchSetTemplateProgress(type);
  };

  const renderSection = () => {
    switch (currentProgressType) {
      case TEMPLATE_PROGRESS_TYPES.formConfig:
        return <FormConfiguration />;
      case TEMPLATE_PROGRESS_TYPES.embedForm:
        return <PreviewAndEmbed />;
      case TEMPLATE_PROGRESS_TYPES.integrate:
        return <Integration />;
      default:
        return (
          <Flex justify="space-between" align="flex-start">
            <Sidebar />
            <BuildForm />
          </Flex>
        );
    }
  };

  useLayoutEffect(() => {
    if (updated && currentProgressType == TEMPLATE_PROGRESS_TYPES.embedForm) {
      toast({
        title: "Success",
        description: "Template saved successfully",
        status: "success",
        position: "top-right",
        duration: 3000,
        isClosable: true,
      });
      setTemplateUpdated(true);
    }
    if (
      httpStatus == "failed" &&
      currentProgressType == TEMPLATE_PROGRESS_TYPES.embedForm
    ) {
      toast({
        title: "An error occurred.",
        description: "Unable to save template.",
        status: "error",
        position: "top-right",
        duration: 3000,
        isClosable: true,
      });
    }
  }, [updated]);
  const renderPreviousButton = () => {
    if (currentProgressType != TEMPLATE_PROGRESS_TYPES.buildForm)
      return (
        <Button
          className="position-end pr-5 btn--secondary"
          w="84px"
          h="32px"
          borderRadius="4px"
          style={{
            marginTop: "12px",
            marginRight: "32px",
            color: "#12344D",
            fontSize: "14px",
            fontWeight: "600",
          }}
          onClick={(e) => handleOnClick(e, "previous")}
        >
          Previous
        </Button>
      );
  };

  const isActiveProgress = (type) => {
    return currentProgressType == type ? "#2C5CC5" : "#92A2B1";
  };

  const handleBreadcrumbChange = (type) => {
    dispatchUpdateTemplateProgressType(type);
  };

  return (
    <Box
      marginLeft="32px"
      marginRight="32px"
      marginBottom="32px"
      border="1px"
      borderRadius="md"
      borderColor="gray.200"
    >
      {templateUpdated && <Redirect to="/forms" />}
      <Box
        className="dashboard__header-wrapper"
        minH="56px"
        position="relative"
        //width="1376px"
      >
        <Flex
          align="center"
          justify="center"
          mt="16px"
          mb="16px"
          h="24px"
          style={{
            margin: "0",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: `translate(${-50}%, ${-50}%)`,
          }}
        >
          <Flex
            align="center"
            justify="center"
            cursor="pointer"
            onClick={() =>
              handleBreadcrumbChange(TEMPLATE_PROGRESS_TYPES.buildForm)
            }
            color={isActiveProgress(TEMPLATE_PROGRESS_TYPES.buildForm)}
          >
            <WorkFlow_1_Icon
              color={isActiveProgress(TEMPLATE_PROGRESS_TYPES.buildForm)}
            />
            <Text
              fontSize="14px"
              fontWeight="600"
              color={isActiveProgress(TEMPLATE_PROGRESS_TYPES.buildForm)}
            >
              Edit Form
            </Text>
          </Flex>
          <ArrowIcon />
          <Flex
            align="center"
            justify="center"
            cursor="pointer"
            onClick={() =>
              handleBreadcrumbChange(TEMPLATE_PROGRESS_TYPES.formConfig)
            }
            color={isActiveProgress(TEMPLATE_PROGRESS_TYPES.formConfig)}
          >
            <WorkFlow_2_Icon
              color={isActiveProgress(TEMPLATE_PROGRESS_TYPES.formConfig)}
            />
            <Text
              fontSize="14px"
              fontWeight="600"
              color={isActiveProgress(TEMPLATE_PROGRESS_TYPES.formConfig)}
            >
              Configure Form settings
            </Text>
          </Flex>
          <ArrowIcon />
          <Flex
            align="center"
            justify="center"
            cursor="pointer"
            onClick={() =>
              handleBreadcrumbChange(TEMPLATE_PROGRESS_TYPES.integrate)
            }
            color={isActiveProgress(TEMPLATE_PROGRESS_TYPES.integrate)}
          >
            <WorkFlow_3_Icon
              color={isActiveProgress(TEMPLATE_PROGRESS_TYPES.integrate)}
            />
            <Text
              fontSize="14px"
              fontWeight="600"
              color={isActiveProgress(TEMPLATE_PROGRESS_TYPES.integrate)}
            >
              Integrate
            </Text>
          </Flex>
          <ArrowIcon />
          <Flex
            align="center"
            justify="center"
            cursor="pointer"
            onClick={() =>
              handleBreadcrumbChange(TEMPLATE_PROGRESS_TYPES.embedForm)
            }
            color={isActiveProgress(TEMPLATE_PROGRESS_TYPES.embedForm)}
          >
            <WorkFlow_4_Icon
              color={isActiveProgress(TEMPLATE_PROGRESS_TYPES.embedForm)}
            />
            <Text
              fontSize="14px"
              fontWeight="600"
              color={isActiveProgress(TEMPLATE_PROGRESS_TYPES.embedForm)}
            >
              Embed form
            </Text>
          </Flex>
        </Flex>
        <Box display="flex" className="position-end">
          {renderPreviousButton()}
          <Button
            bg="#12344D"
            w="56px"
            h="32px"
            borderRadius="4px"
            style={{
              marginTop: "12px",
              marginBottom: "12px",
              marginRight: "16px",
              fontSize: "14px",
              fontWeight: "600",
            }}
            onClick={(e) => handleOnClick(e, "next")}
          >
            {currentProgressType == TEMPLATE_PROGRESS_TYPES.embedForm
              ? "Done"
              : "Next"}
          </Button>
        </Box>
      </Box>
      {/* body */}
      <Box backgroundColor="#F5F7F9" h="100%" display="table" w="100%">
        {renderSection()}
      </Box>
    </Box>
  );
};
const mapStateToProps = (state) => {
  return {
    currentProgressType: state.templateProgressType,
    httpStatus: state.templates.status,
    updated: state.templates.updated,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchSetTemplateProgress: bindActionCreators(
      setTemplateProgressType,
      dispatch
    ),
    dispatchUpdateTemplateProgressType: bindActionCreators(
      updateTemplateProgressType,
      dispatch
    ),
    dispatchUpdateTemplate: bindActionCreators(updateTemplate, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
